import { Component,EventEmitter,Output } from '@angular/core';
import { SecurityService } from '../../services/security/security.service';
import { Router} from '@angular/router';

@Component({
  selector: 'app-acceso',
  templateUrl: './acceso.component.html',
  styleUrls: ['./acceso.component.scss']
})
export class AccesoComponent   {

  @Output() cerrarListaAcceso: EventEmitter<boolean>;
  rol: any;
  loading:boolean = false;
  isLoading:boolean= false;
  save:boolean;
  isDisabled:boolean = true;
  isDisabledd:boolean = false;
  dataUser:any;
  

  nombre:string = ''
  sistema:string = ''

  name = 'Angular';
  tabIndex  = 0;
  

  constructor(private securityService:SecurityService,private router:Router) {
    this.cerrarListaAcceso = new EventEmitter();
    this.save= false;

    try {
      this.dataUser = this.securityService.dataUser;   
      this.nombre =this.dataUser.nombre;
    } catch (error) {
      this.router.navigate(['/usuarios/listado']);
    }

   }


  CerrarPopUp(){
    this.cerrarListaAcceso.emit();
  }
  CambiarTab(Numero: number){

    this.tabIndex = Numero;
    this.isDisabled= false;
    this.isDisabledd= true;
    this.save = true;
  }
  GetSistema(mensaje:string){
   this.sistema = mensaje;
  }

  Atras(){
    this.tabIndex  = 0;
    this.isDisabled= true;
    this.isDisabledd= false;
    this.save = false;
    this.sistema = '';
  }

}
